import {
  array,
  object,
  type output,
} from 'zod';
import { countryValidationSchema } from './nomination-validation.schema';

export const MAX_ASSOCIATED_COUNTRIES = 5;

export const associatedCountriesRequestSchema = object({
  associatedCountries: array(countryValidationSchema)
    .min(1, { error: 'Select at least one associated country.' })
    .max(MAX_ASSOCIATED_COUNTRIES, {
      error: `Select no more than ${MAX_ASSOCIATED_COUNTRIES} associated countries.`,
    })
    .refine((countries) => countries.every((country) => country.countryCode !== 'N/A'), {
      error: 'Do not select N/A as an associated country.',
    }),
});

export type AssociatedCountriesRequest = output<typeof associatedCountriesRequestSchema>;
